import React from 'react';
import PropTypes from 'prop-types';
import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import './ClearButton.less';

export default function ClearButton({ handleClick }) {
  return (
    <LinkV2
      role="button"
      sizes="extraSmall"
      variant="primary"
      className="clear-button"
      onClick={handleClick}
    >
      Clear
    </LinkV2>
  );
}

ClearButton.propTypes = {
  handleClick: PropTypes.func,
};
